import common from "@store/theme/common";
import { setThemeCollection } from "@store/theme/config";

const themes = { common };

export type ThemeName = keyof typeof themes;
export default setThemeCollection<ThemeName>(themes, "common");
